module.exports = __webpack_public_path__ + "static/img/materialsInfo1t4.f3b7699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1t4.png
// module id = qhqt
// module chunks = 2